import awaitWrap from '../../../../procedures/await-wrap';
import httpWrap from '../../../../procedures/http-wrap';
import router from '../../../../router';
import action from '../../../abstract/action';

const handle = async (
  {
    $vs,
    item,
    reloadList,
    model: {
      api: {
        softDelete,
      },
    },
  },
) => {
  $vs.dialog({
    accept: async () => await httpWrap({
      $vs,
      action: softDelete,
      success: { text: 'Szablon został usunięty' },
      onSuccess: reloadList,
    })(item),
    type: 'confirm',
    color: 'primary',
    title: 'Usunięcie szablonu',
    text: await awaitWrap(({ id }) => `Czy na pewno chcesz usunąć szablon?`)(item),
    acceptText: 'Usuń',
    cancelText: 'Wróć',
  });
};

export default action({
  label: 'Usuń',
  icon: 'TrashIcon',
  main: () => false,
  handle,
});
